"use client";
import * as React from "react";
const SvgHomeRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6.26 13.16v-4.2h3.48v4.2c0 .46.39.84.87.84h2.6c.48 0 .87-.38.87-.84V7.27h1.48c.4 0 .6-.47.29-.73L8.58.21a.9.9 0 0 0-1.16 0L.15 6.54c-.3.26-.12.73.28.73h1.48v5.89c0 .46.4.84.87.84h2.6c.49 0 .88-.38.88-.84" }));
export {
  SvgHomeRound as default
};
